const Urls = {
  CHROME: 'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
  FIREFOX: 'https://addons.mozilla.org/en-US/firefox/addon/ether-metamask/',
  EDGE_CHROMIUM: 'https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US',
  OPERA: 'https://addons.opera.com/en-gb/extensions/details/metamask-10/',
};
export default Urls;